import type { FreightProvider } from './freight-settings.types';

// Get Providers
export const FREIGHT_GET_PROVIDERS_REQUEST = 'FREIGHT_GET_PROVIDERS_REQUEST';
export const getProvidersRequest = () => ({
  type: FREIGHT_GET_PROVIDERS_REQUEST,
});

export const FREIGHT_GET_PROVIDERS_SUCCESS = 'FREIGHT_GET_PROVIDERS_SUCCESS';
export const getProvidersSuccess = (providers: FreightProvider[]) => ({
  type: FREIGHT_GET_PROVIDERS_SUCCESS,
  providers,
});

export const FREIGHT_GET_PROVIDERS_ERROR = 'FREIGHT_GET_PROVIDERS_ERROR';
export const getProvidersError = (error: string) => ({
  type: FREIGHT_GET_PROVIDERS_ERROR,
  error,
});

// Disconnect Provider
export const FREIGHT_DISCONNECT_PROVIDER_REQUEST = 'FREIGHT_DISCONNECT_PROVIDER_REQUEST';
export const disconnectProviderRequest = (sellerFreightProviderId: number) => ({
  type: FREIGHT_DISCONNECT_PROVIDER_REQUEST,
  sellerFreightProviderId,
});

export const FREIGHT_DISCONNECT_PROVIDER_SUCCESS = 'FREIGHT_DISCONNECT_PROVIDER_SUCCESS';
export const disconnectProviderSuccess = () => ({
  type: FREIGHT_DISCONNECT_PROVIDER_SUCCESS,
});

export const FREIGHT_DISCONNECT_PROVIDER_ERROR = 'FREIGHT_DISCONNECT_PROVIDER_ERROR';
export const disconnectProviderError = (error: string) => ({
  type: FREIGHT_DISCONNECT_PROVIDER_ERROR,
  error,
});
